import {
  ConnectMomentLevelThumbnail,
  ConnectMomentSummaryThumbnail,
} from "@/components/shared/entity-thumbnails";
import { useConnectActivity } from "@/lib/api/activities";
import type { ActivityInteractionThumbnailProps } from "@/lib/activities/registry";
import { useConversationParticipants } from "@/lib/hooks/conversations/use-conversation-participants";
import { getQuestionById } from "@somethings-ui/core/connect-questions";

export function ConnectMomentInteractionThumbnail({
  entityId,
  index,
  context,
}: ActivityInteractionThumbnailProps) {
  const { data: activity } = useConnectActivity(entityId);
  const { mentor, teen } = useConversationParticipants(context);

  if (index === 0) {
    return (
      <ConnectMomentSummaryThumbnail
        mentorName={mentor.name ?? "Mentor"}
        mentorAvatarUrl={mentor.avatarUrl}
        teenName={teen.name ?? "Teen"}
        teenAvatarUrl={teen.avatarUrl}
      />
    );
  }

  const level = (index - 1) as 0 | 1 | 2;
  const questionId = activity?.config.mentor_answers[level]?.question_id;
  const questionText = questionId
    ? getQuestionById(questionId)?.text
    : undefined;

  return (
    <ConnectMomentLevelThumbnail
      level={level}
      questionText={questionText}
      mentorName={mentor.name ?? "Mentor"}
      mentorAvatarUrl={mentor.avatarUrl}
      teenName={teen.name ?? "Teen"}
      teenAvatarUrl={teen.avatarUrl}
    />
  );
}
